import styled from 'styled-components/native';

export const ButtonSwiper = styled.TouchableOpacity<{ left?: boolean }>`
  position: absolute;
  ${(p) => (p.left ? 'left: 64px;' : 'right: 64px;')}
`;
